import { Button as MuiButton, ButtonProps } from '@mui/material'

/**
 * Convert currency to symbol.
 */
export const Button = (props: ButtonProps): JSX.Element => {
  let name: string = 'Unknown'
  if (typeof props.children === 'string') {
    name = props.children
  } else {
    if (typeof props.children === 'object' && props.children !== null && 'props' in props.children) {
      name = props.children.props.children
    }
  }

  return <MuiButton
    data-cy={`button-${name}`}
    {...props}
  />
}
